import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UnstakingStepThreeBg from '../../../../../../../assets/stake/unstaking-step-three-l3p.svg';
import Header from '../../../../../../../components/Stake/header';
import L3pWbnbUniIcon from '../../../../../../../assets/images/L3P_WBNB.png';
import * as l3pWbnbUniStakeActions from '../../../../../../../actions/l3p-wbnb-uni-stake-actions';
import Details from '../../../../../../../components/Stake/frame/details';
import { formatToken } from '../../../../../../../helpers/token-helper';

const UnstakeDetails = () => {
  const dispatch = useDispatch();
  const { amount } = useSelector((state) => state.L3PWBNBUNIstake.stake);
  const unstakedValue = `${formatToken(amount, 10)} L3P/WBNB`;

  const descriptions = [
    'Staking Rewards will stop being earned as soon as you click "Unstake" and initiate the unstaking process.',
  ];

  return (
    <>
      <Header
        icon={L3pWbnbUniIcon}
        title='L3P/WBNB-Unstaking'
        onClickBack={() => dispatch(l3pWbnbUniStakeActions.unstakeSettings())}
      />
      <Details
        title='You are unstaking:'
        token={unstakedValue}
        buttonClick={() => dispatch(l3pWbnbUniStakeActions.unstakeSend({ amount }))}
        descriptions={descriptions}
        textButton='Unstake'
        stepBg={UnstakingStepThreeBg}
      />
    </>
  );
};

export default UnstakeDetails;
